import { PromotionalCard } from '@vfde-brix/ws10/promotional-card';
import { getTotalTauschbonusAmount } from '@vfde-sails/page-options';
import { replacePlaceholders } from '@vfde-sails/utils';
import { startAppListening } from '../../../app/listener';
import { mountPromotionalCardById } from '../../../components/PromotionalCard';
import { selectCustomerConfig } from '../../app/slice';
import { setInitialState } from '../slice';
import { RootState } from '../../../app/store';

/**
 * Mounts the tauschbonus promotionalCard
 * and replaces the tauschbonusValue placeholder immediately
 */
export const mountTauschbonusPromotionalCard = (containerId: string): PromotionalCard | null => {
    const promotionalCard = mountPromotionalCardById(containerId);

    /* istanbul ignore if */
    if (!promotionalCard) {
        return null;
    }

    listenForUpdates(promotionalCard);

    return promotionalCard;
};

const listenForUpdates = (promotionalCard: PromotionalCard) => {
    startAppListening({
        actionCreator: setInitialState,
        effect: (action, listenerApi) => {
            const state = listenerApi.getState();
            update(state, promotionalCard);

            const { customerConfig } = action.payload;
            const { isTauschbonusEligible } = customerConfig;
            const shouldShowPromotionalCard = isTauschbonusEligible;

            promotionalCard?.toggleContainer(!shouldShowPromotionalCard, true, false);
        },
    });

    startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).isHardwareOnly !== selectCustomerConfig(previousState).isHardwareOnly
        ,
        effect: (_action, listenerApi) => {
            const state = listenerApi.getState();
            const customerConfig = selectCustomerConfig(state);
            const { isHardwareOnly, isTauschbonusEligible } = customerConfig;
            const shouldShowPromotionalCard = !isHardwareOnly && isTauschbonusEligible;

            promotionalCard?.toggleContainer(!shouldShowPromotionalCard, true, false);
        },
    });
};

/**
 * Updates the tauschbonus promotionalCard
 */
const update = (state: RootState, promotionalCard: PromotionalCard) => {
    const customerConfig = selectCustomerConfig(state);
    const tauschbonusValue = getTotalTauschbonusAmount(customerConfig.deviceId!) || 0;
    const stdLabel = replacePlaceholders(promotionalCard.getPropertyByKey('stdLabel'), { tauschbonusValue });
    promotionalCard.update({ stdLabel });
};
